/* eslint no-use-before-define: 0 */
/* AUTO GENERATE FILE - DO NOT EDIT */
import dynamic from 'next/dynamic';

// collections of all tenants' layout
const layouts: Map<string, any> = new Map();

layouts.set(
  'karavan_desktop',
  dynamic(() =>
    import('./_template/desktop/_module/Layout').then((mod) => mod.Layout),
  ),
);

layouts.set(
  'karavan_mobile',
  dynamic(() =>
    import('./_template/mobile/_module/Layout').then((mod) => mod.Layout),
  ),
);

layouts.set(
  'meatdeli_desktop',
  dynamic(() =>
    import('./meatdeli/desktop/_module/Layout').then((mod) => mod.Layout),
  ),
);

layouts.set(
  'meatdeli_mobile',
  dynamic(() =>
    import('./_template/mobile/_module/Layout').then((mod) => mod.Layout),
  ),
);

layouts.set(
  'phongvu_desktop',
  dynamic(() =>
    import('./phongvu/desktop/_module/Layout').then((mod) => mod.Layout),
  ),
);

layouts.set(
  'phongvu_mobile',
  dynamic(() =>
    import('./phongvu/mobile/_module/Layout').then((mod) => mod.Layout),
  ),
);

layouts.set(
  'soibien_desktop',
  dynamic(() =>
    import('./_template/desktop/_module/Layout').then((mod) => mod.Layout),
  ),
);

layouts.set(
  'soibien_mobile',
  dynamic(() =>
    import('./_template/mobile/_module/Layout').then((mod) => mod.Layout),
  ),
);

layouts.set(
  'umbala_desktop',
  dynamic(() =>
    import('./umbala/desktop/_module/Layout').then((mod) => mod.Layout),
  ),
);

layouts.set(
  'umbala_mobile',
  dynamic(() =>
    import('./_template/mobile/_module/Layout').then((mod) => mod.Layout),
  ),
);

layouts.set(
  'vnshop_desktop',
  dynamic(() =>
    import('./vnshop/desktop/_module/Layout').then((mod) => mod.Layout),
  ),
);

layouts.set(
  'vnshop_mobile',
  dynamic(() =>
    import('./_template/mobile/_module/Layout').then((mod) => mod.Layout),
  ),
);

export default layouts;

export const templates = {
  "desktop": [
    {
      "pathname": "/account/orders/[orderId].tsx",
      "query": "orderId",
      "regex": "/account/orders/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/account/quotation/[token].tsx",
      "query": "token",
      "regex": "/account/quotation/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/account/return-order/[orderId].tsx",
      "query": "orderId",
      "regex": "/account/return-order/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/block-categories/[categoryId].tsx",
      "query": "categoryId",
      "regex": "/block-categories/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/brands/[brandId].tsx",
      "query": "brandId",
      "regex": "/brands/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/c/[slug].tsx",
      "query": "slug",
      "regex": "/c/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/categories/[menuItemId].tsx",
      "query": "menuItemId",
      "regex": "/categories/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/confirm-payment/[orderId].tsx",
      "query": "orderId",
      "regex": "/confirm-payment/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/content/[id].tsx",
      "query": "id",
      "regex": "/content/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/cua-hang/[providerId].tsx",
      "query": "providerId",
      "regex": "/cua-hang/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/landing/[id].tsx",
      "query": "id",
      "regex": "/landing/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/p/[slug].tsx",
      "query": "slug",
      "regex": "/p/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/products/detail/[productId].tsx",
      "query": "productId",
      "regex": "/products/detail/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/seller-categories/[sellerCategoryId].tsx",
      "query": "sellerCategoryId",
      "regex": "/seller-categories/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/sellers/[sellerId].tsx",
      "query": "sellerId",
      "regex": "/sellers/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/tin-tuc/[slug].tsx",
      "query": "slug",
      "regex": "/tin-tuc/([^/\\[\\]]+)$"
    }
  ],
  "mobile": [
    {
      "pathname": "/account/orders/[orderId].tsx",
      "query": "orderId",
      "regex": "/account/orders/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/account/quotation/[token].tsx",
      "query": "token",
      "regex": "/account/quotation/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/account/return-order/[orderId].tsx",
      "query": "orderId",
      "regex": "/account/return-order/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/block-categories/[categoryId].tsx",
      "query": "categoryId",
      "regex": "/block-categories/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/brands/[brandId].tsx",
      "query": "brandId",
      "regex": "/brands/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/c/[slug].tsx",
      "query": "slug",
      "regex": "/c/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/categories/[menuItemId].tsx",
      "query": "menuItemId",
      "regex": "/categories/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/confirm-payment/[orderId].tsx",
      "query": "orderId",
      "regex": "/confirm-payment/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/content/[id].tsx",
      "query": "id",
      "regex": "/content/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/cua-hang/[providerId].tsx",
      "query": "providerId",
      "regex": "/cua-hang/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/landing/[id].tsx",
      "query": "id",
      "regex": "/landing/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/my/address/[id].tsx",
      "query": "id",
      "regex": "/my/address/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/p/[slug].tsx",
      "query": "slug",
      "regex": "/p/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/products/[sku]/combos/[id].tsx",
      "query": "id",
      "regex": "/products/[sku]/combos/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/products/detail/[productId].tsx",
      "query": "productId",
      "regex": "/products/detail/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/seller-categories/[sellerCategoryId].tsx",
      "query": "sellerCategoryId",
      "regex": "/seller-categories/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/sellers/[sellerId].tsx",
      "query": "sellerId",
      "regex": "/sellers/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/tin-tuc/[slug].tsx",
      "query": "slug",
      "regex": "/tin-tuc/([^/\\[\\]]+)$"
    },
    {
      "pathname": "/vat/[orderId].tsx",
      "query": "orderId",
      "regex": "/vat/([^/\\[\\]]+)$"
    }
  ]
};
  